<template>
  <div class="legal-page container py-5 pt-4">
    <h1 class="mb-3 text-primary-emphasis">Termos de Uso</h1>
    <template v-if="loading">
      <p class="text-muted small">Carregando documento...</p>
    </template>
    <template v-else-if="docUrl">
      <p class="text-muted small mb-4">Versão {{ docVersion }} · Publicado em {{ docDate }}</p>
      <iframe :src="docUrl" class="legal-iframe" title="Termos de Uso" />
      <p class="mt-2 small text-muted">
        <a :href="docUrl" target="_blank" rel="noopener noreferrer">Abrir em nova aba ↗</a>
      </p>
    </template>
    <template v-else>
      <p class="text-muted small mb-4">Última atualização: 16 de abril de 2026.</p>
      <iframe src="/docs/legal/termos-de-uso.html" class="legal-iframe" title="Termos de Uso" />
    </template>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getLegalDocuments } from '@/services/legalService.js'

const loading = ref(true)
const docUrl = ref('')
const docVersion = ref(null)
const docDate = ref('')

onMounted(async () => {
  try {
    const docs = await getLegalDocuments()
    const doc = docs.find(d => d.doc_type === 'termos_uso')
    if (doc) {
      docUrl.value = doc.file_url
      docVersion.value = doc.version
      docDate.value = new Date(doc.created_at).toLocaleDateString('pt-BR')
    }
  } catch {
    // silencioso — fallback para HTML estático
  } finally {
    loading.value = false
  }
})
</script>

<style scoped>
.legal-page { min-height: 60vh; }
.legal-iframe { width: 100%; min-height: 70vh; border: 1px solid #dee2e6; border-radius: 8px; }
</style>
